module.exports = __webpack_public_path__ + "static/media/empty10_ratecards_anim.31bc7562.svg";